import React, { useEffect } from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'Tabs',
    breadcrumbName: 'Tabs',
  },
];

const Tabs_Component = () => {
  useEffect(() => {
    new IMI.Tab(document.querySelector('[data-rule="tab"]'));
  }, []);

  return (
    <>
      <PageHeader title="Tab" breadcrumb={{ routes }} subTitle="Tabs" style={{ padding: 10 }} />

      <div className="MF_area">
        <div className="tab" data-rule="tab" data-parent="#tab_area">
          <div className="selected" data-target="#tab1">Tab1</div>
          <div data-target="#tab2">Tab2</div>
          <div data-target="#tab3">Tab3</div>
        </div>
        <div id="tab_area" className="tab_content">
          <div id="tab1" className="tab_child show">Tab Content 1</div>
          <div id="tab2" className="tab_child">Tab Content 2</div>
          <div id="tab3" className="tab_child">Tab Content 3</div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<div class="tab" data-rule="tab" data-parent="#tab_area">
    <div class="selected" data-target="#tab1">tab1</div>
    <div data-target="#tab2">tab2</div>
    <div data-target="#tab3">tab3</div>
  </div>
  <div id="tab_area" class="tab_content">
    <div id="tab1" class="tab_child show">Tab Content1</div>
    <div id="tab2" class="tab_child">Tab Content2</div>
    <div id="tab3" class="tab_child">Tab Content3</div>
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`var tabs = document.querySelectorAll('[data-rule="tab"]');
for (var i = 0; i < tabs.length; i++){ new Tab(tabs[i]) }`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


    </>
  );
}

export default Tabs_Component;
